import { LinearProgress, Toolbar } from "@mui/material";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { StoreInterfaces } from "../../types/store";
import Header from "../AppBar/Header";
import Overlay from "../Overlay/Overlay";
import { StyledLayoutContainer } from "./StyledLayoutContainer";
import { StyledLayoutOutletContainer } from "./StyledLayoutOutletContainer";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const isLoading: boolean = useSelector(
    (state: StoreInterfaces) => state.ui.loading,
  );

  return (
    <StyledLayoutContainer id="layout-container">
      <Overlay show={isLoading} />
      <div className="absolute z-auto top-0 left-0 right-0">
        {isLoading && <LinearProgress />}
      </div>
      <Header />
      <Toolbar />
      <StyledLayoutOutletContainer id="layout-children-container">
        {children}
      </StyledLayoutOutletContainer>
    </StyledLayoutContainer>
  );
};

export default Layout;
